// libraries
import { useState, useContext } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import firebase from "../firebase/firebase";
import CKEditor from "ckeditor4-react";
import { v4 as uuidv4 } from "uuid";

import ImgCrop from "antd-img-crop";
import { Upload } from "antd";
import "antd/dist/antd.css";

// styles
import "../styles/SubmitRecipe.css";

// icons
import { IoIosArrowDown } from "react-icons/io";

// context
import UserContext from "../context/user";

// assets
// import bg from "../assets/bg_2.jpg";
import imgPlaceholder from "../assets/placeholder-img.png";

// components
import Hero from "../components/Hero";
import Newsletter from "../components/Newsletter";
import IngredientField from "../components/SubmitRecipe/IngredientField";
import Loading from "../components/Loading";
import TimePicker from "../components/SubmitRecipe/TimePicker";

// firestore
const recipesCollection = firebase.firestore().collection("recipes");

const SubmitRecipe = () => {
  // use context
  const { user, loading, setLoading } = useContext(UserContext);

  // use history
  const history = useHistory();

  // use toast
  const { addToast } = useToasts();

  // uuid
  const uuid = uuidv4();

  // use state
  const [recipe, setRecipe] = useState("");
  const [category, setCategory] = useState("select");
  const [meal, setMeal] = useState("select");
  const [username, setUserName] = useState("");
  const [cooktime, setCooktime] = useState("");
  const [ingredientsNumber, setIngredientsNumber] = useState("");
  const [ingredientList, setIngredientList] = useState([{ value: "" }]);
  const [instructions, setInstructions] = useState("");
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [instagramUrl, setInstagramUrl] = useState("");
  const [facebookUrl, setFacebookUrl] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [image, setImage] = useState();
  const [imageFile, setImageFile] = useState(null);
  const [isTimerOpen, setIsTimerOpen] = useState(false);
  const [fileList, setFileList] = useState([]);

  function handleSubmit(e) {
    e.preventDefault();

    const isEmpty =
      !recipe ||
      !category ||
      category === "select" ||
      !meal ||
      meal === "select" ||
      !cooktime ||
      loading ||
      validateIngredient();

    if (imageFile === null || isEmpty) {
      addToast("Please fill all the fields", {
        appearance: "error",
      });
    } else {
      setLoading(true);
      uploadImageToFBStorage(postRecipeToDB);
    }
  }

  const validateIngredient = () => {
    ingredientList.forEach((item) => {
      if (item === "") return true;
    });

    return false;
  };

  const postRecipeToDB = async (imageUrl) => {
    let recipeObject = {
      recipe,
      category,
      meal,
      ingredientsNumber,
      ingredients: ingredientList,
      instructions,
      status: "pending",
      userToken: user.uid,
      user: user.displayName,
      recommended: false,
      youtube: youtubeUrl,
      instagram: instagramUrl,
      facebook: facebookUrl,
      website: websiteUrl,
      cooktime,
      image: imageUrl,
      uuid,
    };
    await recipesCollection
      .doc(uuid)
      .set(recipeObject)
      .then(() => {
        addToast("Thanks for submitting. Let us review it!", {
          appearance: "success",
        });
        setLoading(false);
        history.push("/");
      })
      .catch((e) => {
        setLoading(false);
        addToast("Couldnt't submit your recipe! Please try again.", {
          appearance: "error",
        });
      });
  };

  const handleImageSelect = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImageFile(e.target.files[0]);
      const reader = new FileReader();
      reader.onloadend = function () {
        setImage(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleChange = (e, index) => {
    const { value } = e.target;
    const newList = [...ingredientList];
    newList[index].value = value;
    setIngredientList(newList);
  };

  const AddMoreIngredient = () => {
    setIngredientList([...ingredientList, { value: "" }]);
  };

  const handleDelete = (index) => {
    let newList = [...ingredientList];
    newList.splice(index, 1);
    setIngredientList(newList);
  };

  const uploadImageToFBStorage = (callback) => {
    const uploadTask = firebase
      .storage()
      .ref(`/images/${imageFile.name}`)
      .put(imageFile);
    uploadTask.on(
      "state_changed",
      () => console.log(),
      console.error,
      () => {
        firebase
          .storage()
          .ref("images")
          .child(imageFile.name)
          .getDownloadURL()
          .then((url) => {
            callback(url);
          });
      }
    );
  };

  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    setImageFile(newFileList[0]?.originFileObj ?? null);
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  if (!user) {
    addToast("Please login before submitting a recipe!", {
      appearance: "error",
    });
    return <Redirect to="/" />;
  }

  return (
    <>
      <Hero
        // image={bg}
        title="Submit Recipe"
        breadName="Submit Recipe"
        singleProduct={false}
      />
      <section
        className="ftco-section"
        onClick={(e) => {
          if (isTimerOpen && e.target.id !== "timer-index")
            setIsTimerOpen(false);
        }}
      >
        {loading && <Loading fixed={true} />}
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7">
              <form className="billing-form">
                <div className="row align-items-end">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="firstname">Recipe</label>
                      <input
                        type="text"
                        name="recipe"
                        value={recipe}
                        onChange={(e) => setRecipe(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="firstname">Username</label>
                      <input
                        type="text"
                        name="username"
                        value={username}
                        onChange={(e) => setUserName(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="category">Category</label>
                      <div className="select-wrap">
                        <div className="icon">
                          <span className="ion-ios-arrow-down">
                            <IoIosArrowDown />
                          </span>
                        </div>
                        <select
                          name="category"
                          className="form-control"
                          value={category}
                          onChange={(e) => setCategory(e.target.value)}
                        >
                          <option value="select">Select</option>
                          <option value="vegetarian">Vegetarian</option>
                          <option value="vegan">Vegan</option>
                          <option value="keto">Keto</option>
                          <option value="pescatarian">Pescatarian</option>
                          <option value="mediterranean">Mediterranean</option>
                          <option value="kids">Kids</option>
                          <option value="healthy">Healthy</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="meal">Meal</label>
                      <div className="select-wrap">
                        <div className="icon">
                          <span className="ion-ios-arrow-down">
                            <IoIosArrowDown />
                          </span>
                        </div>
                        <select
                          name="meal"
                          className="form-control"
                          value={meal}
                          onChange={(e) => setMeal(e.target.value)}
                        >
                          <option value="select">Select</option>
                          <option value="breakfast">Breakfast</option>
                          <option value="lunch">Lunch</option>
                          <option value="dinner">Dinner</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="cooktime">Cook Time</label>
                      <TimePicker
                        isOpen={isTimerOpen}
                        setIsOpen={setIsTimerOpen}
                        setCooktime={setCooktime}
                        cooktime={cooktime}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="ingredientsNumber">
                        No. of Ingredients
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="ingredientsNumber"
                        value={ingredientsNumber}
                        onChange={(e) => setIngredientsNumber(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group ingredients">
                      <label htmlFor="ingredients">Ingredients</label>
                      {ingredientList.map((item, i) => (
                        <IngredientField
                          key={i}
                          index={i}
                          value={item.value}
                          handleChange={handleChange}
                          handleDelete={handleDelete}
                          ingredientList={ingredientList}
                        />
                      ))}
                      <span
                        onClick={AddMoreIngredient}
                        className="submit-recipe-add-more"
                      >
                        Add more
                      </span>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="ingredients">Cooking Instructions</label>
                      <CKEditor
                        data={instructions}
                        onChange={(evt) =>
                          setInstructions(evt.editor.getData())
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="facebook-url"
                        placeholder="Facebook Url (Optional)"
                        value={facebookUrl}
                        onChange={(e) => setFacebookUrl(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="instagram-url"
                        placeholder="Instagram Url (Optional)"
                        value={instagramUrl}
                        onChange={(e) => setInstagramUrl(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="youtube-url"
                        placeholder="Youtube Url (Optional)"
                        value={youtubeUrl}
                        onChange={(e) => setYoutubeUrl(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="website-url"
                        placeholder="Website Url (Optional)"
                        value={websiteUrl}
                        onChange={(e) => setWebsiteUrl(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <br />
                    <div className="submit-recipe-img-upload">
                      <label className="col-12 p-0">Select Recipe Image</label>
                      {/* <label htmlFor="submit-recipe-img-upload">
                        <img
                          src={image == null ? imgPlaceholder : image}
                          alt="submit-recipe"
                        />
                      </label>
                      <input
                        id="submit-recipe-img-upload"
                        type="file"
                        accept=".jpg, .jpeg, .png"
                        onChange={(e) => handleImageSelect(e)}
                      /> */}
                      <ImgCrop rotate>
                        <Upload
                          listType="picture-card"
                          fileList={fileList}
                          onChange={onChange}
                          onPreview={onPreview}
                        >
                          {fileList.length < 1 && "+ Upload"}
                        </Upload>
                      </ImgCrop>
                    </div>
                  </div>
                  <div className="col-md-12 row mt-4 justify-content-center">
                    <br />
                    <div
                      className="btn btn-primary py-3 px-4 submit-recipe-btn"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Submit Recipe
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Newsletter />
    </>
  );
};

export default SubmitRecipe;
